export enum Titles {
  Herr = 'Herr',
  Frau = 'Frau',
  Firma = 'Firma'
}

